import { Injectable } from '@angular/core';
import { VuConnectionHttpService } from './vu-connection-http.service';

@Injectable()
export class ScreenService {

  constructor(
    private vuConnectionHttpService: VuConnectionHttpService,
  ) {
  }

  switchScreen(enabled: boolean) {
    this.vuConnectionHttpService.switchScreen(enabled);
  }
}
